// extracted by mini-css-extract-plugin
export default {"skeleton__head":"styles_skeleton__head__+JYIr","skeleton__column":"styles_skeleton__column__RH6kV","table__skeleton":"styles_table__skeleton__9v6Cg"};